import { Card, CardBody, CardHeader } from "reactstrap";
import { faSliders } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Switcher } from "../../../Switcher";
import { useTranslation } from "react-i18next";

interface Props {
  showDetails: boolean;
  setShowDetails: (value: ((prevState: boolean) => boolean) | boolean) => void;
}

export function ShowDetailsCard({ showDetails, setShowDetails }: Props) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <FontAwesomeIcon icon={faSliders} /> {t("common.view")}
      </CardHeader>
      <CardBody>
        <Switcher
          value={t("common.showDetails")}
          setIsActive={setShowDetails}
          isActive={showDetails}
        />
      </CardBody>
    </Card>
  );
}
